/***********************************************************
Product Variants
***********************************************************/
function initVariants() {
  const variants = window.VARIANTS || [];
  const colorOptions = document.querySelectorAll(".color-option");
  const sizeOptions = document.querySelectorAll(".size-option");
  const hiddenInput = document.getElementById("selected-variant-id");
  let selectedColor = null;
  let selectedSize = null;

  const updateSizes = () => {
    sizeOptions.forEach(sizeEl => {
      const sizeValue = sizeEl.dataset.optionValue;
      const match = variants.find(v =>
        v.options.includes(selectedColor) &&
        v.options.includes(sizeValue)
      );

      if (match && match.available) {
        sizeEl.classList.remove("disabled");
        sizeEl.style.opacity = "1";
      } else {
        sizeEl.classList.add("disabled");
        sizeEl.style.opacity = "0.3";
      }
    });
  };

  const updateVariant = () => {
    const variant = variants.find(v =>
      v.options.includes(selectedColor) &&
      v.options.includes(selectedSize)
    );
    if (variant) {
      hiddenInput.value = variant.id;
    }
  };

  colorOptions.forEach(colorEl => {
    colorEl.addEventListener("click", () => {
      colorOptions.forEach(el => el.classList.remove("selected"));
      colorEl.classList.add("selected");
      selectedColor = colorEl.dataset.optionValue;
      updateSizes();
      updateVariant();
    });
  });

  sizeOptions.forEach(sizeEl => {
    sizeEl.addEventListener("click", () => {
      if (sizeEl.classList.contains("disabled")) return;
      sizeOptions.forEach(el => el.classList.remove("selected"));
      sizeEl.classList.add("selected");
      selectedSize = sizeEl.dataset.optionValue;
      updateVariant();
    });
  });
}